__turbopack_context__.v({
  "closeButton": "style-module-scss-module__kFT-6G__closeButton",
  "closing": "style-module-scss-module__kFT-6G__closing",
  "description": "style-module-scss-module__kFT-6G__description",
  "featuresContainer": "style-module-scss-module__kFT-6G__featuresContainer",
  "left": "style-module-scss-module__kFT-6G__left",
  "marketsWrapper": "style-module-scss-module__kFT-6G__marketsWrapper",
  "messageContainer": "style-module-scss-module__kFT-6G__messageContainer",
  "messageContent": "style-module-scss-module__kFT-6G__messageContent",
  "messageText": "style-module-scss-module__kFT-6G__messageText",
  "messageTriangle": "style-module-scss-module__kFT-6G__messageTriangle",
  "opening": "style-module-scss-module__kFT-6G__opening",
  "popupContainer": "style-module-scss-module__kFT-6G__popupContainer",
  "popupContent": "style-module-scss-module__kFT-6G__popupContent",
  "popupImage": "style-module-scss-module__kFT-6G__popupImage",
  "popupImageMobile": "style-module-scss-module__kFT-6G__popupImageMobile",
  "popupWrapper": "style-module-scss-module__kFT-6G__popupWrapper",
  "right": "style-module-scss-module__kFT-6G__right",
  "title": "style-module-scss-module__kFT-6G__title",
  "titleContainer": "style-module-scss-module__kFT-6G__titleContainer",
});
